<script>
import {
  MarkerLayer,
  decorateMapPropsMixin,
  config
} from '@ali/amap-traffic-brain-fe-common-map';

export default {
  name: 'CongestSmallMarkerLayer',

  _isBaseClass: false,

  extends: MarkerLayer,

  mixins: [decorateMapPropsMixin('list')],

  $overlayDecorator(info) {
    const { startPoint, duration } = info;
    const [x, y] = startPoint
      .replace('POINT(', '')
      .replace(')', '')
      .split(' ');
    const classNames = [
      'common-map__marker__congest-small',
      duration <= 15 ? 'fresh' : 'default'
    ];
    return {
      content: `<div class="${classNames.join(' ')}"></div>`,
      position: [+x, +y],
      anchor: 'bottom-center',
      zIndex: config.zIndexOrder.indexOf('overlayMarker') * 100
    };
  },

  $getPropsKey(info) {
    const { id } = info;
    return id;
  }
};
</script>
